export default {
  setting: [],
  booths: [],
  storeOptions: [],
  branchUserPersons: [],
  stores: [],
  boothList: [],
  preOrders: [],
  preOrderById: null,
};
